module.exports = __webpack_public_path__ + "img/icon-payment-nfc-green@3x.89de4644.png";